import { Checkbox, Dropdown, TooltipV2 } from '@cimplico/components';
import { useNavigate } from 'react-router-dom';
import { TemplateProcedureOverview } from '../../types/procedure';
import { formatMixedCase } from '../../utilities/formatting';
import WorkpaperProcedureRoleBadge from '../workpaper-procedures/WorkpaperProcedureRoleBadge';
import WorkpaperProcedureTypeBadge from '../workpaper-procedures/WorkpaperProcedureTypeBadge';

type ProcedureRowProps = {
    isDisabled?: boolean;
    procedure: TemplateProcedureOverview;
    checked?: boolean;
    onChecked: (id: string) => void;
};

function ProcedureRow({ isDisabled, procedure, checked, onChecked }: ProcedureRowProps): JSX.Element {
    const navigate = useNavigate();

    const formattedEntityNames = procedure.entityTypes.map((e) => {
        return formatMixedCase(e);
    });

    function redirectToEditProcedure(): void {
        navigate(`edit/${procedure.id}`);
    }

    return (
        <div className="py-4 border-b">
            <div className="flex items-bottom justify-between">
                <div className="flex items-start gap-2 max-w-[70%]">
                    <Checkbox onChange={(): void => onChecked(procedure.id)} disabled={isDisabled} checked={checked} />
                    <p className="text-gray-900 text-xs font-medium">{procedure.reference}</p>
                    <div className="flex flex-col">
                        <p className="text-gray-700 text-sm leading-4 mb-1">{procedure.name}</p>
                        <p className="text-gray-500 text-xs whitespace-pre-line">{procedure.description}</p>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <WorkpaperProcedureTypeBadge entityType={procedure.entityTypes[0]} />
                    {procedure.entityTypes.length > 1 && (
                        <TooltipV2 message={formattedEntityNames.slice(1)} position="right">
                            <label className="block mr-1 text-sm text-gray-500 leading-5 font-medium">
                                +{procedure.entityTypes.length - 1}
                            </label>
                        </TooltipV2>
                    )}

                    <WorkpaperProcedureRoleBadge role={procedure.role} />
                    {!isDisabled && (
                        <Dropdown direction="bottom">
                            <Dropdown.Option label="Edit Procedure" onClick={redirectToEditProcedure} value="edit" />
                        </Dropdown>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ProcedureRow;
